import { ComplianceComponent } from "@/features";
import { Deal } from "@/types";
import { useOutletContext } from "react-router-dom"

type ClientOutletContext = {
  deals: Deal[]
  isLoading: boolean
}

export const CompliancePage = () => {
  const { deals, isLoading } = useOutletContext<ClientOutletContext>()
  return <ComplianceComponent deals={deals} isLoading={isLoading} />;
}